import { Root } from 'react-dom/client';
import { HostState } from './HostState';

export const state = {
    fadeMs: 350,
    current: { kind: 'empty' } as HostState,
    hideTimer: null as number | null,
    root: null as Root | null
}
